import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

export function usePrompt(message, when) {
  const navigator = useContext(UNSAFE_NavigationContext).navigator;

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;

    navigator.push = (...args) => {
      const confirmLeave = window.confirm(message);
      if (confirmLeave) {
        push(...args);
      }
    };

    return () => {
      navigator.push = push;
    };
  }, [when, message, navigator]);
}
